import { EyeOutlined, LeftOutlined } from "@ant-design/icons";
import { Button, Card, Col, Row, Spin, Table, Tooltip, Typography } from "antd";
import Notiflix from "notiflix";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import MainLayout from "../../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../../components/layouts/TopContent";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../../../customer.config";
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";

const { Text } = Typography;

const capitalizeWords = (value) =>
  typeof value === "string"
    ? value.replace(
        /\w\S*/g,
        (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
      )
    : value;

const detailColumns = [
  {
    dataIndex: "description",
    key: "description",
    width: "45%",
    onCell: () => ({
      style: {
        backgroundColor: "#F5F5F5",
      },
    }),
    render: (text) => (
      <Text strong style={{ color: "#000000" }}>
        {text}
      </Text>
    ),
  },
  {
    dataIndex: "item",
    key: "item",
    width: "55%",
    render: (value) => value ?? "-",
  },
];

function DetailChequeBook(props) {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [isLeavesLoading, setIsLeavesLoading] = useState(true);
  const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);
  const [chequeDetails, setChequeDetails] = useState({});
  const [leavesList, setLeavesList] = useState([]);
  const [activeTabKey, setActiveTabKey] = useState("chequeLeaves");

  useEffect(() => {
    if (state?.id === undefined || state?.id === null) {
      BOM.AlertMsg(cnt.DANGER, "Cheque Book Request id is required");
    }

    getCheque();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCheque = () => {
    const url = `${apiConfig.Cheques}/${state?.id}`;
    const body = { session };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(
          cnt.DANGER,
          err?.defaultUserMessage || "Failed to fetch cheque book request",
        );
      } else {
        setIsLoading(false);
        setChequeDetails({
          accountNo: res?.accountNo,
          requestedStatus: res?.requestedStatus,
          chequeLeaves: res?.chequeLeaves,
          deliveryMode: res?.deliveryMode,
          deliveryAddress1: res?.deliveryAddress1,
          deliveryAddress2: res?.deliveryAddress2,
          deliveryAddress3: res?.deliveryAddress3,
          orderDetails: res?.orderDetails,
        });
        getChequeLeaves(res?.firstChequeNo);
      }
    });
  };

  const handleUpdateDeliveryStatus = () => {
    Notiflix.Confirm.show(
      "Are you sure?",
      "Update delivery status to Delivered",
      "Yes",
      "No",
      function () {
        const payload = {
          requestedStatus: "delivered",
          locale: "en",
          dateFormat: "dd MMMM yyyy",
          method: "PUT",
          session,
        };

        const url = `${apiConfig.Cheques}/${state?.id}`;

        setIsUpdatingStatus(true);
        BOM.FetchReqAction(payload, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            setIsUpdatingStatus(false);
          } else {
            BOM.AlertMsg(
              cnt.SUCCESS,
              labelConfig.updateChequeBookDeliveryStatusMsg,
            );
            setIsUpdatingStatus(false);
            getCheque();
          }
        });
      },
      function () {
        // No button
      },
    );
  };

  const getChequeLeaves = (firstChequeNo) => {
    const url = `${apiConfig.Cheques}/${firstChequeNo}/chequeleaves`;
    const body = { session };

    setIsLeavesLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLeavesLoading(false);
        BOM.AlertMsg(
          cnt.DANGER,
          err?.defaultUserMessage || "Failed to fetch cheque leaves",
        );
      } else {
        const objList = res?.pageItems || res || [];
        let tempArray = [];

        objList.forEach((item) => {
          tempArray.push({
            key: item?.id,
            id: item?.id,
            chequeBookNo: item?.chequeBookNo,
            accountNo: item?.accountNo,
            chequeDate: item?.chequeDate,
            chequeNo: item?.chequeNo ?? item?.leafNumber ?? item?.serialNumber,
            status: item?.status,
          });
        });

        setLeavesList(tempArray);
        setIsLeavesLoading(false);
      }
    });
  };

  const leavesColumns = [
    {
      title: "Id",
      dataIndex: "id",
    },
    {
      title: "Cheque Book No",
      dataIndex: "chequeBookNo",
    },
    {
      title: "Account No",
      dataIndex: "accountNo",
    },
    {
      title: "Cheque Date",
      dataIndex: "chequeDate",
    },
    {
      title: "Cheque No",
      dataIndex: "chequeNo",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => {
        if (status === "N") return "Not Used";
        if (status === "U") return "Used";
        return status;
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Tooltip title="View Leaf Details">
          <Button
            type="primary"
            icon={<EyeOutlined />}
            shape="round"
            size="small"
            className="of-primaryBtnColor"
            onClick={() =>
              navigate("/view-cheque-leaf-details", {
                state: { ...state, leaf: record },
              })
            }
          />
        </Tooltip>
      ),
    },
  ];

  const leftDetailData = [
    {
      key: "accountNo",
      description: "Account No",
      item: chequeDetails?.accountNo,
    },
    {
      key: "requestedStatus",
      description: "Requested Status",
      item: capitalizeWords(chequeDetails?.requestedStatus),
    },
    {
      key: "chequeLeaves",
      description: "Cheque Leaves",
      item: chequeDetails?.chequeLeaves,
    },
    {
      key: "deliveryMode",
      description: "Delivery Mode",
      item: capitalizeWords(chequeDetails?.deliveryMode),
    },
  ];

  const rightDetailData = [
    {
      key: "deliveryAddress1",
      description: "Delivery Address 1",
      item: capitalizeWords(chequeDetails?.deliveryAddress1),
    },
    {
      key: "deliveryAddress2",
      description: "Delivery Address 2",
      item: capitalizeWords(chequeDetails?.deliveryAddress2),
    },
    {
      key: "deliveryAddress3",
      description: "Delivery Address 3",
      item: capitalizeWords(chequeDetails?.deliveryAddress3),
    },
    {
      key: "orderDetails",
      description: "Order Details",
      item: capitalizeWords(chequeDetails?.orderDetails),
    },
  ];

  const tabList = [{ key: "chequeLeaves", label: "Cheque Leaves" }];

  const contentListNoTitle = {
    chequeLeaves: (
      <Table
        columns={leavesColumns}
        dataSource={leavesList}
        bordered
        pagination={{ position: ["bottomCenter"], pageSize: 10 }}
      />
    ),
  };

  return (
    <MainLayout isEnableRightSidebar={false}>
      <TopContent
        pageTitle={labelConfig.detailChequeBookRequest}
        pageItems={staticConfig.detailChequeBookRequestBreadcrumbItems(state)}
      />
      <Spin spinning={isLoading} size="large">
        <>
          <Card
            style={{
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
            }}
            title={
              <Row
                justify="space-between"
                style={{ alignContent: "center", width: "100%" }}
              >
                <Button
                  icon={<LeftOutlined />}
                  type="text"
                  style={{ marginTop: "auto", marginBottom: "auto" }}
                  onClick={() =>
                    navigate("/manage-cheque-book-request", { state })
                  }
                >
                  <Text
                    style={{
                      marginTop: "auto",
                      marginBottom: "auto",
                      fontSize: 15,
                    }}
                  >
                    Back
                  </Text>
                </Button>

                <Button
                  type="primary"
                  className="of-primaryBtnColor"
                  loading={isUpdatingStatus}
                  onClick={handleUpdateDeliveryStatus}
                  style={{ marginTop: "auto", marginBottom: "auto" }}
                >
                  Update Delivery Status
                </Button>
              </Row>
            }
          >
            <Row gutter={24}>
              <Col span={12}>
                <Table
                  columns={detailColumns}
                  dataSource={leftDetailData}
                  pagination={false}
                  showHeader={false}
                  bordered
                />
              </Col>

              <Col span={12}>
                <Table
                  columns={detailColumns}
                  dataSource={rightDetailData}
                  pagination={false}
                  showHeader={false}
                  bordered
                />
              </Col>
            </Row>
          </Card>

          <Card
            styles={{ header: { borderBottomWidth: 0 } }}
            style={{
              width: "100%",
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
              marginTop: 24,
            }}
            tabList={tabList}
            activeTabKey={activeTabKey}
            onTabChange={(key) => setActiveTabKey(key)}
            tabProps={{ size: "middle" }}
          >
            <Spin spinning={isLeavesLoading} size="large">
              {contentListNoTitle[activeTabKey]}
            </Spin>
          </Card>
        </>
      </Spin>
    </MainLayout>
  );
}

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});

export default connect(mapStateToProps, null)(DetailChequeBook);
